/* Yuko Roots — Dawn theme layer JS (AJAX cart, drawer, bundles, sticky bar) */
(function(){
  'use strict';
  if (window.__yrLoaded) return;   // guard against duplicate includes
  window.__yrLoaded = true;
  const $  = (s, c=document) => c.querySelector(s);
  const $$ = (s, c=document) => Array.from((c||document).querySelectorAll(s));
  const money = c => '₹' + (c/100).toLocaleString('en-IN', {minimumFractionDigits: 0, maximumFractionDigits: 2});

  /* ---------- reveal on scroll ---------- */
  const io = new IntersectionObserver((es)=>{es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}})},{threshold:.12, rootMargin:'0px 0px -7% 0px'});
  function bindReveal(){ $$('.yr-reveal:not(.in)').forEach((el,i)=>{ el.style.transitionDelay=(i%3*80)+'ms'; io.observe(el); }); }
  bindReveal();

  /* ---------- mobile nav ---------- */
  document.addEventListener('click', e=>{
    if(e.target.closest('[data-yr-burger]')) $('#yr-navdrawer')?.classList.add('open');
    if(e.target.closest('[data-yr-navclose]') || e.target.matches('#yr-navdrawer nav a')) $('#yr-navdrawer')?.classList.remove('open');
  });

  /* ---------- cart drawer ---------- */
  const drawer = ()=> $('#yr-cart');
  const scrim  = ()=> $('#yr-scrim');
  function openCart(){ scrim()?.classList.add('show'); drawer()?.classList.add('open'); document.body.style.overflow='hidden'; }
  function closeCart(){ scrim()?.classList.remove('show'); drawer()?.classList.remove('open'); document.body.style.overflow=''; }
  window.yrOpenCart = openCart; window.yrCloseCart = closeCart;

  document.addEventListener('click', e=>{
    if(e.target.closest('[data-yr-cart-open]')){ e.preventDefault(); refreshCart().then(openCart); }
    if(e.target.closest('[data-yr-cart-close]') || e.target.id==='yr-scrim'){ closeCart(); }
  });

  const FREE = parseInt(drawer()?.dataset.freeThreshold || '49900', 10); // in paise/cents

  function renderCart(cart){
    const body = $('#yr-cart-body'); if(!body) return;
    $$('[data-yr-count]').forEach(n=> n.textContent = cart.item_count);
    if(cart.item_count === 0){
      body.innerHTML = '<div class="yr-cart-empty">Your bag is empty.</div>';
    } else {
      body.innerHTML = cart.items.map(it=>{
        const img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i,'_120x$1$2') : '';
        return `<div class="yr-line" data-key="${it.key}">
          <div class="yr-th">${img?`<img src="${img}" alt="${it.product_title}">`:''}</div>
          <div class="yr-li">
            <h4>${it.product_title}</h4>
            <div class="yr-meta">${it.variant_title && it.variant_title!=='Default Title' ? it.variant_title : '1 sheet / 20mL'}</div>
            <div class="yr-lqty">
              <button data-yr-line-dec aria-label="Decrease">−</button>
              <span>${it.quantity}</span>
              <button data-yr-line-inc aria-label="Increase">+</button>
            </div>
          </div>
          <div class="yr-lp">${money(it.final_line_price)}</div>
        </div>`;
      }).join('');
    }
    $('#yr-subtotal') && ($('#yr-subtotal').textContent = money(cart.total_price));
    const left = Math.max(0, FREE - cart.total_price), pct = Math.min(100, Math.round(cart.total_price / FREE * 100));
    const fill = $('#yr-ship-fill'); if(fill) fill.style.width = pct + '%';
    const msg = $('#yr-ship-msg');
    if(msg) msg.innerHTML = left>0 ? `You're <b>${money(left)}</b> away from <b>free shipping</b>` : `🎉 You've unlocked <b>free shipping</b>`;
  }

  function refreshCart(){
    return fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(r=>r.json()).then(cart=>{ renderCart(cart); return cart; })
      .catch(()=>{});
  }
  refreshCart();

  /* line qty change inside drawer */
  document.addEventListener('click', e=>{
    const line = e.target.closest('.yr-line'); if(!line) return;
    const inc = e.target.closest('[data-yr-line-inc]'); const dec = e.target.closest('[data-yr-line-dec]');
    if(!inc && !dec) return;
    const key = line.dataset.key;
    const cur = parseInt(line.querySelector('.yr-lqty span').textContent,10) || 1;
    const qty = Math.max(0, cur + (inc?1:-1));
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
      .then(r=>r.json()).then(renderCart);
  });

  /* ---------- add to cart (AJAX) ---------- */
  function addToCart(id, quantity){
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:id, quantity:quantity||1})})
      .then(r=>r.json());
  }

  document.addEventListener('submit', e=>{
    const form = e.target.closest('[data-yr-pform]'); if(!form) return;
    e.preventDefault();
    const id = (form.querySelector('[name="id"]')||{}).value;
    const qty = parseInt((form.querySelector('[name="quantity"]')||{}).value || '1', 10);
    const btn = form.querySelector('[data-yr-add]');
    if(btn){ btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; btn.disabled = true; }
    addToCart(id, qty).then(()=>refreshCart()).then(()=>{ openCart(); if(btn){ btn.textContent = btn.dataset.label; btn.disabled=false; } });
  });

  /* sticky bar add */
  document.addEventListener('click', e=>{
    const s = e.target.closest('[data-yr-sticky-add]'); if(!s) return;
    const id = s.dataset.variant; const qty = parseInt($('#yr-qty')?.value||'1',10);
    addToCart(id, qty).then(refreshCart).then(openCart);
  });

  /* ---------- quantity stepper ---------- */
  document.addEventListener('click', e=>{
    const b = e.target.closest('[data-yr-qty]'); if(!b) return;
    const input = $('#yr-qty'); if(!input) return;
    let v = Math.max(1, (parseInt(input.value,10)||1) + (b.dataset.yrQty==='up'?1:-1));
    input.value = v;
  });

  /* ---------- bundle / variant selection ---------- */
  document.addEventListener('click', e=>{
    const b = e.target.closest('[data-yr-bundle]'); if(!b) return;
    $$('[data-yr-bundle]').forEach(x=>x.classList.remove('is-on'));
    b.classList.add('is-on');
    const vid = b.dataset.variant, price = b.dataset.price, cmp = b.dataset.compare;
    const hidden = $('#yr-variant-id'); if(hidden && vid) hidden.value = vid;
    $$('[data-yr-sticky-add]').forEach(s=>{ if(vid) s.dataset.variant = vid; });
    if(price && $('.yr-now')) $('.yr-now').textContent = money(parseInt(price,10));
    const wasEl = $('.yr-was');
    if(wasEl){ if(cmp && parseInt(cmp,10)>parseInt(price,10)){ wasEl.textContent = money(parseInt(cmp,10)); wasEl.style.display=''; } else { wasEl.style.display='none'; } }
  });

  /* quantity packs (single-variant 1/3/5) */
  document.addEventListener('click', e=>{
    const b = e.target.closest('[data-yr-pack]'); if(!b) return;
    $$('[data-yr-pack]').forEach(x=>x.classList.remove('is-on'));
    b.classList.add('is-on');
    const input = $('#yr-qty'); if(input && b.dataset.qty) input.value = b.dataset.qty;
  });

  /* ---------- gallery thumbs ---------- */
  document.addEventListener('click', e=>{
    const t = e.target.closest('[data-yr-thumb]'); if(!t) return;
    const main = $('#yr-gmain-img'); if(main) main.src = t.dataset.full;
    $$('[data-yr-thumb]').forEach(x=>x.classList.remove('is-on')); t.classList.add('is-on');
  });

  /* ---------- sticky bar visibility ---------- */
  const sticky = ()=> $('#yr-sticky');
  window.addEventListener('scroll', ()=>{ const s = sticky(); if(!s) return; s.classList.toggle('show', window.scrollY > 600); }, {passive:true});
})();
